"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
exports.useProfileStyle = core_1.makeStyles((theme) => core_1.createStyles({
    buttonDeleteContainer: {
        marginBottom: theme.spacing(3)
    },
    root: {
        '&> form': {
            position: 'relative'
        },
        '&> form > button': {
            marginTop: 0
        },
        margin: '16px auto',
        maxWidth: 720,
        minHeight: 1024,
        padding: theme.spacing(2),
        position: 'relative',
        width: '100%'
    }
}));
//# sourceMappingURL=profile.style.js.map